import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'


const Keys = {
  ADD_USERS: 'add_users',
  CLEAR: 'clear'
}

export const state = {
  onlineUsersGUID: []
}
export const mutations = {
  [Keys.ADD_USERS](state, users) {
    if (!users || !users.length) {
      return
    }

    state.onlineUsersGUID = users
  },


  [Keys.CLEAR](state) {
    state.onlineUsersGUID = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state }){
    let onlineUserIdList =await post(Endpoints.getUrl('user.online-list'), { },null,{preventConcurrent:false})
    // console.log('onlineUserIdList',onlineUserIdList)
    if(onlineUserIdList.success)
    commit(Keys.ADD_USERS,onlineUserIdList.data)
  },
  async getOnlineUserDetail({ dispatch, commit, state }, userIds) {

    // clear
    // commit(Keys.CLEAR)

    // var key = 'data-banks'

    // if (options.force !== true) {
    //   var cached = await dispatch('cache/get', key, { root: true })
    //   if (cached != null) {
    //     commit(Keys.ADD_USERS, cached)
    //     return
    //   }
    // }

    // var result = await post(Endpoints.getUrl('bank.list'))

    let usersWithDetails =await post(Endpoints.getUrl('user.list'), { },null,{preventConcurrent:false})




    if (usersWithDetails.success) {
      // var cacheObj = {
      //   key,
      //   seconds: 24 * 60 * 60,
      //   value: result.data.items
      // }
      //
      // dispatch('cache/set', cacheObj, { root: true })
      return usersWithDetails.data.items.filter(x=>state.onlineUsersGUID.some(y=>y==x.id))
    }
  },

  updateOnlineUsers({ commit },users) {
    commit(Keys.ADD_USERS,users)
  },
  clear({ commit }) {
    commit(Keys.CLEAR)
  }
}
export const getters = {
  all: state => {
    return state.onlineUsersGUID
  },
  getById: state => id => {
    return state.onlineUsersGUID.find(x => x === id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
